import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, vShow as _vShow, withDirectives as _withDirectives, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2887d073"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = { class: "v-card-title mt-24" }

import { withDefaults } from 'vue';
import { LoaderIcon } from '@/components/atoms';
import { IOptionsSelect } from '@/types';

interface IProps {
  title?: string;
  subtitle?: string;
  label?: string;
  loading?: boolean;
  textTooltip?: string;
  icon?: string;
  iconColor?: string;
  iconBgColor?: string;
  elevation?: string;
  hasDropdownList?: boolean;
  hasTabs?: boolean;
  noPadding?: boolean;
  footer?: boolean;
  optionsDropDown?: IOptionsSelect[];
  isCalendarSelect?: boolean;
  counter?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeCard',
  props: {
    title: {},
    subtitle: {},
    label: {},
    loading: { type: Boolean, default: false },
    textTooltip: {},
    icon: {},
    iconColor: {},
    iconBgColor: {},
    elevation: { default: '' },
    hasDropdownList: { type: Boolean },
    hasTabs: { type: Boolean, default: false },
    noPadding: { type: Boolean },
    footer: { type: Boolean },
    optionsDropDown: {},
    isCalendarSelect: { type: Boolean, default: false },
    counter: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "card",
    elevation: props.elevation
  }, {
    default: _withCtx(() => [
      (_ctx.title)
        ? (_openBlock(), _createBlock(_component_v_card_title, {
            key: 0,
            class: "bg-white title-card"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("p", _hoisted_2, _toDisplayString(props.title), 1)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_divider, { class: "color-divider" }),
      _createVNode(_component_v_card_item, {
        class: _normalizeClass(["card-container", `${props.noPadding && 'px-0 pt-0'}`])
      }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(_unref(LoaderIcon)), { class: "ma-auto w-100" }, null, 512)), [
            [_vShow, props.loading]
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _renderSlot(_ctx.$slots, "default")
          ], 512), [
            [_vShow, !props.loading]
          ])
        ]),
        _: 3
      }, 8, ["class"])
    ]),
    _: 3
  }, 8, ["elevation"]))
}
}

})